// Helpers for requests to api_go (appConfig.routerApi.baseUrl).

// api_go answers 400 to an empty or placeholder header, so those count as "no ecosystem".
const INVALID_ECOSYSTEM_IDS = ['', 'undefined', 'null']

export function ecosystemHeaderValue() {
  const eid = String(window.localStorage.getItem('eid') || '').trim()
  return INVALID_ECOSYSTEM_IDS.includes(eid) ? null : eid
}

// api_go answers its errors as {"error": "<message>"}; the status is what tells the cases apart.
export function clusteringErrorMessage(vm, response) {
  switch (response && response.status) {
    case 422:
      return vm.$gettext("Your ecosystem doesn't have routing zones configured for this country.")
    case 503:
      return vm.$gettext("Routing zones couldn't be loaded. Please try again in a few minutes.")
    case 400:
      return vm.$gettext('Your session ecosystem is invalid. Please log in again.')
    default:
      return vm.$gettext("Shippings couldn't be clustered. Please try again.")
  }
}
